var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-array-input',{attrs:{"required":"","label":"チャットチャンネル","name":"roomChannels","placeholder":"例: メイン,雑談","value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }